'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

BEGIN.pageScript = BEGIN.pageScript || {
  init: {}
};

BEGIN.pageScript = function () {
  // コンストラクタ  =================================================================
  function init() {
    initMainvisualSlider();
    initPickupSlider();
    initHotTopicsSlider();
    initLimitedModal();

    BEGIN.common.initBoynaSliderSec();
    BEGIN.common.initInstagramLala();
    BEGIN.common.initRankingTab();
  }

  /*
  *  トップスライダー
  *
  */
  function initMainvisualSlider() {
    var slider = new MainvisualSlider();
    slider.init();
  }

  var MainvisualSlider = function () {
    function MainvisualSlider() {
      _classCallCheck(this, MainvisualSlider);

      this.slider = $('#js-mainvisualSlide');
      this.thumbnail = $('#js-mainvisualThumbnail');
      this.thumbNode = $('.js-mainvisualThumbnailNode');
      this.progress = $('.js-sliderProgress');
      this.sliderVar;
      this.slideChangeFlg = true;
    }

    _createClass(MainvisualSlider, [{
      key: 'init',
      value: function init() {
        var _this = this;
        _this.setMainSlider();
        _this.setThumbnail();
      }
    }, {
      key: 'setMainSlider',
      value: function setMainSlider() {
        var _this = this;
        var progressEl = _this.progress[0];
        var autoPlayDur = 8000;

        this.sliderVar = new Swiper(_this.slider[0], {
          loop: true,
          // loopAdditionalSlides: 1,
          // slidesPerView: 1,
          centeredSlides: true,
          autoplay: {
            delay: autoPlayDur,
            disableOnInteraction: false
          },
          speed: 600,
          pagination: {
            el: "#js-mainvisualDots"
          },
          navigation: {
            nextEl: "#js-mainvisualArrow .next",
            prevEl: "#js-mainvisualArrow .prev"
          },
          on: {
            slideChangeTransitionStart: function slideChangeTransitionStart() {
              progressEl.style.transitionTimingFunction = 'linear', progressEl.style.transitionDuration = '0s', progressEl.style.height = '0%';
            },
            slideChangeTransitionEnd: function slideChangeTransitionEnd() {
              progressEl.style.transitionDuration = autoPlayDur + 'ms', progressEl.style.height = '100%';
            },
            slideChange: function slideChange(swiper) {
              if (!_this.slideChangeFlg) return;
              _this.toggleThumbCurrent(swiper.realIndex);
              console.log('slideChange');
            }
          }
        });
      }
    }, {
      key: 'setThumbnail',
      value: function setThumbnail() {
        var _this = this;

        _this.thumbNode.eq(0).addClass('is-current');

        _this.thumbNode.on('click', function () {
          var index = $(this).index();
          _this.slideChangeFlg = false;
          _this.toggleThumbCurrent(index);
          _this.sliderVar.slideTo(index + 1);
          _this.slideChangeFlg = true;
        });
      }
    }, {
      key: 'toggleThumbCurrent',
      value: function toggleThumbCurrent(index) {
        var _this = this;

        console.log('toggleThumbCurrent');

        _this.thumbNode.removeClass('is-current');
        _this.thumbNode.eq(index).addClass('is-current');
      }
    }]);

    return MainvisualSlider;
  }();

  /*
  *  PICK UPスライダー
  *
  */


  function initPickupSlider() {
    var $pickup = new PickupSlider($('.js-pickup'));
    $pickup.init();
  }

  var PickupSlider = function () {
    function PickupSlider(target) {
      _classCallCheck(this, PickupSlider);

      this.target = target;
      this.mainSlider = this.target.find('.js-pickupSlider');
      this.creditSlider = this.target.find('.js-pickupCreditSlider');
      this.thumbnails = this.target.find('.js-pickupThumb .pickupThumb_node');
    }

    _createClass(PickupSlider, [{
      key: 'init',
      value: function init() {
        var _this = this;
        _this.thumbnails.eq(0).addClass('is-current');
        _this.setMainSlider();
        _this.setCreditSlider();
        _this.thumbnails.on('click', function () {
          _this.thumbnailChangeEvent($(this).index());
          _this.mainSlider.slick('slickGoTo', $(this).index());
        });
      }
    }, {
      key: 'setMainSlider',
      value: function setMainSlider() {
        var _this = this;
        _this.mainSlider.slick({
          autoplay: true,
          appendArrows: $('.js-pickupGalleryControl'),
          asNavFor: _this.creditSlider
        });
        _this.mainSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          _this.thumbnailChangeEvent(nextSlide);
        });
      }
    }, {
      key: 'setCreditSlider',
      value: function setCreditSlider() {
        this.creditSlider.slick({
          arrows: false,
          fade: true,
          asNavFor: this.mainSlider
        });
      }
    }, {
      key: 'thumbnailChangeEvent',
      value: function thumbnailChangeEvent(index) {
        this.thumbnails.removeClass('is-current');
        this.thumbnails.eq(index).addClass('is-current');
      }
    }]);

    return PickupSlider;
  }();

  /*
  * HOT TOPICSスライダー
  *
  */


  function initHotTopicsSlider() {
    var slider = new HotTopicsSlider($('.js-featureSlider'));
    slider.init();
  }

  var HotTopicsSlider = function () {
    function HotTopicsSlider(target) {
      _classCallCheck(this, HotTopicsSlider);

      this.slider = target;
      this.sliderVar;
      this.breakPoint = 767;
      this.sliderFlg;
    }

    _createClass(HotTopicsSlider, [{
      key: 'init',
      value: function init() {
        this.loadEvent();
        this.resizeEvent();
      }
    }, {
      key: 'loadEvent',
      value: function loadEvent() {
        var _this = this;
        BEGIN.data.$window.on('load', function () {
          if (BEGIN.data.winW < _this.breakPoint) {
            _this.sliderFlg = false;
          } else {
            _this.setSlider();
            _this.sliderFlg = true;
          }
        });
      }
    }, {
      key: 'resizeEvent',
      value: function resizeEvent() {
        var _this = this;
        BEGIN.data.$window.on('resize', function () {
          if (BEGIN.data.winW <= _this.breakPoint && _this.sliderFlg) {
            _this.sliderVar.destroy(false, true);
            _this.sliderFlg = false;
          } else if (BEGIN.data.winW > _this.breakPoint && !_this.sliderFlg) {
            _this.setSlider();
            _this.sliderFlg = true;
          }
        });
      }
    }, {
      key: 'setSlider',
      value: function setSlider() {
        var _this = this;
        this.sliderVar = new Swiper(_this.slider[0], {
          loop: true,
          loopAdditionalSlides: 2,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false
          },
          speed: 1000,
          slidesPerView: 4
        });
      }
    }]);

    return HotTopicsSlider;
  }();

  /*
  * LIMITED ITEMS モーダル
  *
  */


  function initLimitedModal() {
    var modal = new LimitedModal($('.js-limitedModal'));
    modal.init();
  }

  var LimitedModal = function () {
    function LimitedModal(target) {
      _classCallCheck(this, LimitedModal);

      this.modal = target;
      this.modalInner = $('.js-limitedModalInner');
      this.modalImgSlider = $('.js-limitedImgSlider');
      this.modalCreditSlider = $('.js-limitedCreditSlider');
      this.modalClose = $('.js-limitedModalClose');
      this.modalThumbs = $('.js-limitedImgThumbnail');
      this.modalThumbsNode = $('.js-limitedImgThumbnailNode');
      this.thumbArrow = $('.js-limitedImgThumbnailArrow');
      this.modalThumbsNodeWidth = this.modalThumbsNode.eq(0).outerWidth(true);
      this.modalThumbsTotalWidth = this.modalThumbsNodeWidth * this.modalThumbs.length;
      this.imgSliderOpt = {
        asNavFor: this.modalCreditSlider,
        arrows: false
      };
      this.creditSliderOpt = {
        asNavFor: this.modalImgSlider,
        arrows: false,
        fade: true
      };
      this.currentIndex = 0;
    }

    _createClass(LimitedModal, [{
      key: 'init',
      value: function init() {
        var _this = this;
        _this.modalImgSlider.slick(_this.imgSliderOpt).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          _this.thumbsToggleClass(nextSlide);
          _this.currentIndex = nextSlide;
        });

        _this.modalCreditSlider.slick(_this.creditSliderOpt);

        _this.modalThumbsNode.on('click', function () {
          var index = $(this).index();
          _this.modalImgSlider.slick('slickGoTo', index);
          _this.thumbsToggleClass(index);
        });

        _this.modalClose.on('click', function () {
          _this.modal.removeClass('is-open');
        });
        $(document).on('click', '[data-limited-id]', function () {
          _this.openModal($(this));
        });
        this.thumbArrow.on('click', function () {
          _this.arrowChangeSlide();
        });
      }
    }, {
      key: 'thumbsToggleClass',
      value: function thumbsToggleClass(index) {
        var _this = this;
        _this.modalThumbsNode.removeClass('is-current');
        _this.modalThumbsNode.eq(index).addClass('is-current');
        _this.modalThumbs.scrollLeft(_this.modalThumbsNodeWidth * index);
      }
    }, {
      key: 'openModal',
      value: function openModal($self) {
        var index = $self.data('limited-id') - 1;

        this.modalInner.scrollTop(0);
        this.modal.addClass('is-open');
        this.modalImgSlider.slick('slickGoTo', index, true);
        this.thumbsToggleClass(index);
      }
    }, {
      key: 'arrowChangeSlide',
      value: function arrowChangeSlide() {
        var _this = this;
        this.modalImgSlider.slick('slickGoTo', _this.currentIndex + 1, false);
      }
    }]);

    return LimitedModal;
  }();

  return {
    init: init
  };
}();

BEGIN.common.init(BEGIN.pageScript.init);